import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AppService } from '../app.service';

@Component({
  selector: 'app-send-email',
  templateUrl: './send-email.component.html',
  styleUrls: ['./send-email.component.css']
})
export class SendEmailComponent implements OnInit {

  sendEmailFormGroup = new FormGroup({
    username: new FormControl('')
  })

  done = false

  wrongInput = false
  wrongInputReason = ""

  constructor(private serv: AppService) { }

  ngOnInit(): void {
  }

  onSubmit() {
    this.serv.resetSendEmail(this.sendEmailFormGroup.get('username').value).subscribe(ret => {
      if (!ret['result']) {
        this.wrongInput = true
        this.wrongInputReason = ret['reason']
      } else {
        this.done = true
      }
    })
  }

}
